import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faStar,faCircleNotch, faArrowLeftLong } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { formatCurrency } from '../utils/currencyUtils';
import Select from "react-select";
import { toast } from 'react-hot-toast';

//FILE UPLOAD
function Copyprofile() {
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const hasType = state?.trade_id;
    if (!hasType) {
        navigate('/copyexpert', { replace: true });
    }else{
        setLoading(false)
    }
  }, [state, navigate]);
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        type: 'crypto',
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
        amount: 0,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    let total = 0;
    const applyWalletBalance = (list) =>
      list.map(item => {
        const value = item.price;
        total += value;
        return {
          ...item,
          amount: 0
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
      ...applyWalletBalance(fiat),
      ...applyWalletBalance(stock)
    ];
    const sorted = merged.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock]);
  const [tradeID, setTradeID] = useState(state?.trade_id);
  const [copyExperts, setCopyExperts] = useState([]);
  const [duration, setDuration] = useState('seven');
  const [autoTrades, setAutoTrades] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchautotrade1: true, trade_id : tradeID })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          setAutoTrades(data.trades);
        }else{
          toast.error(data.message);
        }
    })
    .catch(err => {
    })
  }, [user]); 
  function safeJSONParse(value) {
    try {
        return typeof value === "string" ? JSON.parse(value) : value;
    } catch {
        return value || {};
    }
  }
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchCopyExpert: true, trade_id : tradeID })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.copytrade) {
        const info = data.copytrade.info || {};
        const parsedInfo = {
          ...info,
          seven: safeJSONParse(info.seven),
          thirty: safeJSONParse(info.thirty),
          ninety: safeJSONParse(info.ninety),
        };
        const updatedCopyTrade = {
          ...data.copytrade,
          info: parsedInfo
        };
        setCopyExperts(updatedCopyTrade);
      }
    })
    .catch(err => {
        console.error('Error fetching plans!')
    })
  }, [user, tradeID]);
  const durationoptions = [
    { value: "seven", label: "7D" },
    { value: "thirty", label: "30D" },
    { value: "ninety", label: "90D" },
  ];

  if (!copyExperts || typeof copyExperts !== "object" || (Array.isArray(copyExperts) && copyExperts.length === 0)) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }
  
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Copy Experts" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Copy Experts" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row mb-5">
                <div className="col-12 g-4">
                    <Link to="/copyexpert" className="noLink"><FontAwesomeIcon icon={faArrowLeftLong} style={{fontSize: '18px'}} /></Link>
                </div>
                <div className="col-lg-4 col-md-6 g-4">
                    <div className="mycard p-3" style={{backgroundColor:'#ffffff0f'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="rounded-3 d-flex align-items-center justify-content-center overflow-hidden" style={{border:'4px solid white',width:'62px',height:'62px',marginTop:'-30px'}}>
                                <img src={`/uploads/${copyExperts.trader_photo}`} alt={copyExperts.trader_name} style={{height:'100%',width:'100%',objectFit:'cover'}} />
                            </div>
                            <p className="mb-0 rounded-2 py-1 px-2 text-secondary fw-bold d-inline-block ms-1" style={{backgroundColor:'#ffffff0f', fontSize:'14px'}}>
                                <FontAwesomeIcon icon={faStar} className="text-warning" style={{fontSize: '14px'}} /> {copyExperts.info.rank}</p>
                        </div>
                        <p className="mb-0 mt-3" style={{fontWeight:'900', fontSize:'20px'}}>{copyExperts.trader_name}</p>
                        <p className="mb-0 text-secondary" style={{fontSize:'14px',lineHeight:'120%'}}>{copyExperts.info.desc}</p>
                        <div className="d-flex flex-wrap align-items-center justify-content-between mt-3" style={{gap:'10px'}}>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Join Days</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.join_days ? copyExperts.info.join_days : '--'}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Copiers</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.current_copiers ? copyExperts.info.current_copiers : '--'}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Mock Copiers</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.mock_copiers ? copyExperts.info.mock_copiers : '--'}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Total Copiers</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.total_copiers ? copyExperts.info.total_copiers : '--'}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Closed Portfolios</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.closed_portfolio ? copyExperts.info.closed_portfolio : '--'}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 g-4">
                    <div className="mycard p-3" style={{backgroundColor:'#ffffff0f'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Leading Margin Balance(USDT)</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.margin_balance ? formatCurrency(copyExperts.info.margin_balance) : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>AUM(USDT)</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.aum ? formatCurrency(copyExperts.info.aum) : '--'}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Copiers PnL(USDT)</p>
                                <p className="mb-0 fw-bold text-success" style={{fontSize:'18px'}}>{copyExperts.info.copiers_profit ? formatCurrency(copyExperts.info.copiers_profit) : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Min. Copy Amount(USDT)</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.min_amount ? copyExperts.info.min_amount : '--'}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Profit Sharing</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.profit_share ? formatCurrency(copyExperts.profit_share)+'%' : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Lock Period</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info.lock_period ? copyExperts.info.lock_period : '--'}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 g-4">
                    <div className="mycard p-3" style={{backgroundColor:'#ffffff0f'}}>
                        <div className="d-flex align-items-center justify-content-between mb-2 noSelect">
                            <p className="fw-bold mb-0" style={{fontSize:'18px'}}>Performance</p>
                            <Select 
                                options={durationoptions} 
                                value={durationoptions.find((opt) => opt.value === duration)}
                                onChange={(e) => setDuration(e.value)}
                                styles={darkThemeStyles}
                                className="w-full fw-bold"
                            />
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>ROI</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.roi ? formatCurrency(copyExperts.info[duration]?.roi)+'%' : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>PnL(USDT)</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.pnl ? formatCurrency(copyExperts.info[duration]?.pnl) : '--'}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Sharpe Ratio</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.ratio ? formatCurrency(copyExperts.info[duration]?.ratio) : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Win Rate</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.win_rate ? formatCurrency(copyExperts.info[duration]?.win_rate)+'%' : '--'}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>MDD</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.mdd ? formatCurrency(copyExperts.info[duration]?.mdd)+'%' : '--'}</p>
                            </div>
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Total Positions</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.total_position ? copyExperts.info[duration]?.total_position : '--'}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <div style={{width:'50%'}}>
                                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Profitable Positions</p>
                                <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{copyExperts.info[duration]?.profit_position ? copyExperts.info[duration]?.profit_position : '--'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Copyprofile